import { ReactElement, ReactNode } from 'react';

// Styles.
import styles from '../Header.module.scss';

interface IPopupMenuItemProps {
  label: string;
  to?: string;
  target?: string;
  onClick?: () => void;
}

export const PopupMenuItem = (props: IPopupMenuItemProps): ReactElement => {
  return (
    <a
      className={styles.popupMenuItem}
      href={props.to}
      target={props.target}
      onClick={() => {
        if (props.onClick != null) props.onClick();
      }}
    >
      {props.label}
    </a>
  );
};
